// ─── REVCENTRIQ MODULE DEFINITIONS ───────────────────────────────────────────
// Single source of truth for all 12 IQ modules.
// Import this wherever module data is needed.

export const MODULES = [
  {
    id: "executive",
    label: "ExecutiveIQ",
    accent: "#7c3aed",
    icon: "⬡",
    desc: "C-suite cross-module health at a glance",
    persona: "CRO / CEO",
    sources: ["All modules — cross-source aggregation"],
  },
  {
    id: "revenue",
    label: "RevenueIQ",
    accent: "#2563eb",
    icon: "↗",
    desc: "Revenue trends, targets & pipeline value",
    persona: "Finance / RevOps",
    sources: ["Salesforce", "Stripe", "Chargebee", "QuickBooks"],
  },
  {
    id: "sales",
    label: "SalesIQ",
    accent: "#ea580c",
    icon: "◈",
    desc: "Rep leaderboards, win/loss & deal velocity",
    persona: "VP Sales",
    sources: ["Salesforce", "HubSpot", "Pipedrive"],
  },
  {
    id: "customer",
    label: "CustomerIQ",
    accent: "#059669",
    icon: "◎",
    desc: "Retention, NRR, churn risk & account health",
    persona: "VP Customer Success",
    sources: ["Gainsight", "Salesforce", "Stripe"],
  },
  {
    id: "forecast",
    label: "ForecastIQ",
    accent: "#7c3aed",
    icon: "◇",
    desc: "Pipeline scenarios, commits & accuracy",
    persona: "CRO / Finance",
    sources: ["Salesforce", "HubSpot", "Pipedrive"],
  },
  {
    id: "marketing",
    label: "MarketingIQ",
    accent: "#db2777",
    icon: "◉",
    desc: "Funnel, MQL→SQL conversion & campaign ROI",
    persona: "VP Marketing",
    sources: ["Marketo", "HubSpot"],
  },
  {
    id: "competitive",
    label: "CompetitiveIQ",
    accent: "#d97706",
    icon: "⬡",
    desc: "Win/loss by competitor & market share",
    persona: "Strategy",
    sources: ["Salesforce (competitor fields)", "HubSpot"],
  },
  {
    id: "ops",
    label: "OpsIQ",
    accent: "#0891b2",
    icon: "⬟",
    desc: "CRM health, process compliance & adoption",
    persona: "Head of RevOps",
    sources: ["Salesforce", "HubSpot", "tool usage APIs"],
  },
  {
    id: "support",
    label: "SupportIQ",
    accent: "#e11d48",
    icon: "◈",
    desc: "CSAT, ticket volume & agent performance",
    persona: "Support Director",
    sources: ["Zendesk", "Intercom", "Gainsight"],
  },
  {
    id: "people",
    label: "PeopleIQ",
    accent: "#0d9488",
    icon: "◎",
    desc: "Headcount planning, ramp time & attrition",
    persona: "Sales / HR",
    sources: ["BambooHR", "Salesforce"],
  },
  {
    id: "partner",
    label: "PartnerIQ",
    accent: "#be185d",
    icon: "◇",
    desc: "Partner pipeline, co-sell & enablement",
    persona: "Channel / Alliances",
    sources: ["PartnerStack", "Salesforce"],
  },
  {
    id: "spend",
    label: "SpendIQ",
    accent: "#b45309",
    icon: "◉",
    desc: "CAC, LTV:CAC ratio & GTM cost efficiency",
    persona: "CFO",
    sources: ["QuickBooks", "Stripe", "BambooHR"],
  },
];

// Helper: get module by id
export const getModule = (id) => MODULES.find((m) => m.id === id);
